import { setDataset } from './dataset.js';
import { setStyles } from './style.js';

export interface CreateIframeElementParameters {
    id?: string;
    src?: string;
    srcdoc?: string;
    styles?: Partial<CSSStyleDeclaration>;
    dataset?: Record<string, string>;
}

export const createIframeElement = ({ id, src = '', srcdoc = '', styles = {}, dataset = {} }: CreateIframeElementParameters): HTMLIFrameElement => {
    const iframe = document.createElement('iframe');
    if (id) iframe.id = id;
    //deprecated attributes that still work, with no valid solutions in css/html
    iframe.scrolling = 'no';
    iframe.marginWidth = '0';
    iframe.marginHeight = '0';
    iframe.frameBorder = '0';
    setStyles(iframe, {
        border: '0',
        overflow: 'hidden',
        outline: 'none',
        ...styles,
    });
    setDataset(iframe, dataset);
    if (src) iframe.src = src;
    if (srcdoc) iframe.srcdoc = srcdoc;
    return iframe;
};
